import * as React from 'react';
import { useIntl } from 'react-intl';
import { Container, Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { getPatientAgeInMonthsWithOneDecimal } from 'Utility/patientInfo';
import { exists } from 'neuro-utils';
import { showPatientAgeInMonthsOnForm } from '../../utils';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { formatPartialDate } from 'Utility/date';
import { mfm } from 'neuro-schemas';

const { calculateScore } = mfm;

const MFM = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  const intl = useIntl();
  const fm = (id?: string, values?: { [key: string]: string }): string =>
    id ? intl.formatMessage({ id: id }, values) : '';

  return (
    <HistorySection
      headerText={fm('motor.mfm')}
      newButton={
        <DocumentCreationButton
          name="mfm"
          text="motor.newMfm"
          onClick={startEdit({}, 'mfm')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={2}>{fm('motor.mfm32OrMfm20Short')}</Item>
            <Item xs={6}>{fm('motor.score')}</Item>
          </>
        }
        contentFormat={d => {
          const score = calculateScore(d);
          return (
            <>
              <Item xs={2} id="mfmDate">
                {showPatientAgeInMonthsOnForm(d.date)
                  ? fm('motor.dateAndMonth', {
                      date: formatPartialDate(d.date),
                      months: getPatientAgeInMonthsWithOneDecimal(d.date),
                    })
                  : formatPartialDate(d.date)}
              </Item>
              <Item xs={2}>
                {exists(d.mfm32OrMfm20) && d.mfm32OrMfm20 === 'mfm20'
                  ? 'MFM20'
                  : exists(d.mfm32OrMfm20) && d.mfm32OrMfm20 === 'mfm32'
                    ? 'MFM32'
                    : '-'}
              </Item>
              <Item xs={6}>
                {score !== null ? (
                  <Container>
                    {Object.entries(score).map(([k, s]) => {
                      return (
                        <Item key={k} xs={3}>
                          <div style={{ fontWeight: 100 }}>{k ? fm(`motor.opts.mfm.${k}`) : ''}</div>
                          <div>{`${s.toFixed(2)}%`}</div>
                        </Item>
                      );
                    })}
                  </Container>
                ) : (
                  '-'
                )}
              </Item>
            </>
          );
        }}
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'mfm'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default MFM;
